// extracted by mini-css-extract-plugin
export default {"text":"TranslitingTooltip_text__j2r+P"};